/**
 * GENERATED - DO NOT EDIT.
 * The RBAC matrix of the operator API: each operation's minimum role (FR-12).
 * Source: packages/contract/openapi.yaml (`x-required-role`). Regenerate with `npm run contract:generate`.
 * Generator: openapi-typescript 7.13.0 family. OpenAPI document version: 1.2.0
 * OpenAPI hash: sha256-nwxXVRvPP2G4kvmzRblNWPHVV-8BV978UfuJTHBVVT0
 * Matrix hash: sha256-f2S6kcYgS5m7OHMvrRE41U79w5EvMDMqT1meqiofz_M
 */

/** The three operator-API roles, lowest privilege to highest (FR-12 AC2–AC4). */
export const OPERATOR_ROLES = ["viewer","operator","admin"] as const;
export type OperatorRole = (typeof OPERATOR_ROLES)[number];

/** Every operator-API operation id. */
export type OperationId =
  | "acknowledgeAlert"
  | "approveAuditKey"
  | "connectStream"
  | "createAlertChannel"
  | "createAlertRule"
  | "createSilence"
  | "createSource"
  | "deleteSilence"
  | "exportComplianceMapping"
  | "getAgentActivity"
  | "getAgentRisk"
  | "getAssuranceFinding"
  | "getAssuranceSummary"
  | "getAuditChain"
  | "getDecisionBreakdown"
  | "getDecisionSummary"
  | "getDiscoveredAgent"
  | "getEnforcementSummary"
  | "getEnrolmentFunnel"
  | "getEvent"
  | "getIdentityMcpSummary"
  | "getIdentityTokens"
  | "getMcpTool"
  | "getMcpToolSurface"
  | "getMcpToolSurfaceDrift"
  | "getMetricCatalog"
  | "getMetricSeries"
  | "getOverview"
  | "getService"
  | "getSystemHealth"
  | "getTrace"
  | "listAccessRequests"
  | "listAgents"
  | "listAlertChannels"
  | "listAlertRules"
  | "listAlerts"
  | "listApps"
  | "listAssuranceFindings"
  | "listAuditChains"
  | "listComplianceMapping"
  | "listCoreIntegrity"
  | "listDiscoveredAgents"
  | "listEvents"
  | "listIdentityLifecycle"
  | "listIdentityMcpDenials"
  | "listIntents"
  | "listInteractions"
  | "listMcpGatewayAccess"
  | "listMcpTools"
  | "listPostureDrift"
  | "listPostureFindings"
  | "listServices"
  | "listSilences"
  | "listSources"
  | "listTraces"
  | "registerDiscoveredAgent"
  | "registerSourceKey"
  | "rejectDiscoveredAgent"
  | "revokeSource"
  | "setIntentReviewStatus"
  | "streamEventsSse"
  | "updateAlertRule"
  | "updateSilence";

/**
 * The minimum role each operation requires, derived from `x-required-role` in openapi.yaml.
 * The one source of truth both the Node service and the `core` Worker enforce (FR-12 AC6).
 */
export const REQUIRED_ROLE: Readonly<Record<OperationId, OperatorRole>> = Object.freeze({
  "acknowledgeAlert": "operator",
  "approveAuditKey": "admin",
  "connectStream": "viewer",
  "createAlertChannel": "operator",
  "createAlertRule": "operator",
  "createSilence": "operator",
  "createSource": "admin",
  "deleteSilence": "operator",
  "exportComplianceMapping": "viewer",
  "getAgentActivity": "viewer",
  "getAgentRisk": "viewer",
  "getAssuranceFinding": "viewer",
  "getAssuranceSummary": "viewer",
  "getAuditChain": "viewer",
  "getDecisionBreakdown": "viewer",
  "getDecisionSummary": "viewer",
  "getDiscoveredAgent": "viewer",
  "getEnforcementSummary": "viewer",
  "getEnrolmentFunnel": "viewer",
  "getEvent": "viewer",
  "getIdentityMcpSummary": "viewer",
  "getIdentityTokens": "viewer",
  "getMcpTool": "viewer",
  "getMcpToolSurface": "viewer",
  "getMcpToolSurfaceDrift": "viewer",
  "getMetricCatalog": "viewer",
  "getMetricSeries": "viewer",
  "getOverview": "viewer",
  "getService": "viewer",
  "getSystemHealth": "viewer",
  "getTrace": "viewer",
  "listAccessRequests": "viewer",
  "listAgents": "viewer",
  "listAlertChannels": "viewer",
  "listAlertRules": "viewer",
  "listAlerts": "viewer",
  "listApps": "viewer",
  "listAssuranceFindings": "viewer",
  "listAuditChains": "viewer",
  "listComplianceMapping": "viewer",
  "listCoreIntegrity": "viewer",
  "listDiscoveredAgents": "viewer",
  "listEvents": "viewer",
  "listIdentityLifecycle": "viewer",
  "listIdentityMcpDenials": "viewer",
  "listIntents": "viewer",
  "listInteractions": "viewer",
  "listMcpGatewayAccess": "viewer",
  "listMcpTools": "viewer",
  "listPostureDrift": "viewer",
  "listPostureFindings": "viewer",
  "listServices": "viewer",
  "listSilences": "viewer",
  "listSources": "viewer",
  "listTraces": "viewer",
  "registerDiscoveredAgent": "admin",
  "registerSourceKey": "admin",
  "rejectDiscoveredAgent": "admin",
  "revokeSource": "admin",
  "setIntentReviewStatus": "operator",
  "streamEventsSse": "viewer",
  "updateAlertRule": "operator",
  "updateSilence": "operator",
});
